/* eslint-disable no-param-reassign,no-shadow,no-unused-vars */
import { fetchAzureToken, fetchToken } from '../../services/api';
import { loginWithAzure } from '../../lib/msal';

const state = {
  isLoggedIn: false,
  user: null,
  enterpriseConfiguration: {},
  tokens: {
    access: '',
    refresh: '',
  },
  msAccessToken: '',
};

const getters = {
  isLoggedIn: (state) => state.isLoggedIn,
  getUser: (state) => state.user,
};

const mutations = {
  LOGIN(state, payload) {
    state.isLoggedIn = true;
    state.tokens = payload;
  },
  LOG_OUT(state) {
    state.isLoggedIn = false;
    state.tokens = {
      access: '',
      refresh: '',
    };
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_AZURE_ACCESS_TOKEN(state, token) {
    state.msAccessToken = token;
  },
};

const actions = {
  async login({ commit }, payload) {
    try {
      const { data } = await fetchToken(payload);
      commit('SET_USER', payload.username);
      commit('LOGIN', data);
    } catch (err) {
      throw err;
    }
  },
  async getAzureAccessToken({ commit, dispatch }) {
    const tokenResponse = await loginWithAzure();
    commit('SET_AZURE_ACCESS_TOKEN', tokenResponse.accessToken);
    await dispatch('loginWithAzureTokens', {
      access_token: tokenResponse.accessToken,
      id_token: tokenResponse.idToken,
    });
  },
  async loginWithAzureTokens({ commit, dispatch }, payload) {
    const tokenLoginPayload = {
      ...payload,
      provider: 'azuread-v2-tenant-oauth2',
    };
    const { data } = await fetchAzureToken(tokenLoginPayload);
    commit('SET_USER', data.username);
    commit('LOGIN', data.tokens);
  },
  userSignout({ commit }) {
    commit('LOG_OUT');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
